import React from 'react'

import { Tabs } from 'antd';
import TabpanelDetail from './TabpanelDetail'
// import ReferenceTab from './ReferenceTab';
const { TabPane } = Tabs;

interface propsTypes {
    isEditable: void | any,
    cancelEditable: void | any
}
const AmentiesIndex = (props: propsTypes) => {
    return (
        <Tabs defaultActiveKey="1">
            <TabPane tab="Reference Points" key="1">
                <TabpanelDetail isEditable={props.isEditable} cancelEditable={props.cancelEditable} />
            </TabPane>
        </Tabs>
    )
}

export default AmentiesIndex;

